import axios from "axios";
import { httpStatus } from "./http-status";
import { getLocalTimezone } from "../../src/utils/utils";

const config = {
  baseURL: process.env.REACT_APP_API_URL,
  validateStatus: (status: number) => (status >= httpStatus.StatusOK) && (status < httpStatus.StatusMultipleChoices),
  timeout: 60 * 1000, // Timeout
};
const httpClient = axios.create(config);
httpClient.interceptors.request.use(
  (config) => {
    if (localStorage.getItem("session-id")) {
      config.headers["session-id"] = localStorage.getItem("session-id");
    }
    config.headers["user-timezone"] = getLocalTimezone();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error && error.response && error.response.status && error.response.status === 401) {
      localStorage.removeItem("session-id");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default httpClient;
